import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { usePaymentModalStore } from '../../../store/payment/paymentModalStore';
import { brandTypes } from '../pieces/CardForm/logic';

const cardFormSchema = z.object({
    subMethod: z.string({ message: 'Campo obrigatório' })
        .refine(val => ['CREDIT', 'DEBIT'].includes(val), {
            message: 'Selecioneuma forma de pagamento',
        })
        .default('CREDIT'),
    number: z.string().min(1, { message: 'Campo obrigatório' }),
    expiration: z.string().min(1, { message: 'Campo obrigatório' }),
    cvv: z.string().min(1, { message: 'Campo obrigatório' }),
    name: z
        .string()
        .min(1, { message: 'Campo obrigatório' })
        .refine(val => val.trim().split(' ').length > 1, {
            message: 'Informe o nome completo',
        }),
    // cpf: z
    //     .string()
    //     .min(1, { message: 'Campo obrigatório' })
    //     .refine(val => validateCPFCNPJ(val), {
    //         message: 'CPF ou CNPJ inválido'
    //     }),
    brand: z
        .string({ message: 'Campo obrigatório' })
        .refine(val => brandTypes.includes(val), {
            message: 'Selecione uma bandeira',
        }),
});

export type CardFormSchemaType = z.infer<typeof cardFormSchema>;

export default function useFormModalPaymentCardLogic() {
    const paymentModal = usePaymentModalStore();

    const {
        register,
        handleSubmit,
        getValues,
        formState: { errors, isValid },
        setValue,
        trigger,
        watch,
    } = useForm<CardFormSchemaType>({
        resolver: zodResolver(cardFormSchema),
        mode: 'onBlur',
        defaultValues: {
            subMethod: paymentModal.card?.subMethod || 'CREDIT',
            number: paymentModal.card?.number || '',
            expiration: paymentModal.card?.expiration || '',
            cvv: paymentModal.card?.cvv || '',
            name: paymentModal.card?.name || '',
            brand: paymentModal.card?.brand || '',
        }
    });

    function handleSuccess(data: CardFormSchemaType) {
        if (isValid) {
            paymentModal.update({
                isVisible: false,
                card: {
                    subMethod: data.subMethod as 'CREDIT' | 'DEBIT',
                    brand: data.brand,
                    cvv: data.cvv,
                    name: data.name,
                    number: data.number,
                    expiration: data.expiration,
                },
            });
        }
    }

    const handleError = (_formErrors: typeof errors) => {
        
    };

    return {
        register,
        errors,
        handleSubmit,
        handleSuccess,
        handleError,
        getValues,
        setValue,
        trigger,
        watch,
    };
}
